/**
 * The Center Plan Component.
 *
 * Standalone. Does NOT rely on additional libraries.
 */
(function () {

    /**
     * Object handling a single center plan.
     *
     * @param {HTMLElement} element The element bound to this instance
     * @constructor
     */
    function CenterPlan(element) {

        var /**
             * The identifier of the element.
             *
             * @type {integer}
             */
            identifier,

            /**
             * The settings of the center plan.
             *
             * @type {{floors: {}, shopTitleContainer: HTMLElement|null}}
             */
            settings = {floors: {}, shopTitleContainer: null};

        /**
         * Initializes the center plan.
         */
        function initialize() {
            identifier = parseInt(element.dataset.identifier, 10);

            if (isNaN(identifier)) {
                throw new Error('Unable to initialize center plan: No identifier given.');
            }
            if (!('TYPO3' in window) || !('settings' in TYPO3) || !('centerPlan' in TYPO3.settings) || !(identifier in TYPO3.settings.centerPlan)) {
                throw new Error('Unable to initialize center plan: No settings defined.');
            }

            var shopDefinitions = TYPO3.settings.centerPlan[identifier].shops || {};
            for (var i = shopDefinitions.length; i-->0;) {
                var shop = shopDefinitions[i];
                for (var j = shop.floors.length; j-->0;) {
                    var floor = shop.floors[j];
                    if (!(floor in settings.floors)) {
                        settings.floors[floor] = {shops: {}};
                    }
                    settings.floors[floor].shops[shop.area] = shop;
                }
            }

            settings.shopTitleContainer = element.querySelector('[data-container="shopName"]');

            _initializeFloors();
        }

        /**
         * Sets the shop title.
         *
         * @param {string} shopTitle The shop title to set
         */
        function setShopTitle(shopTitle) {
            if ('string' !== typeof shopTitle) {
                throw new Error('Argument 1 of CenterPlan.setShopTitle has to be of type string, "' + (typeof shopTitle) + '" given.');
            }
            if (null !== settings.shopTitleContainer) {
                settings.shopTitleContainer.textContent = shopTitle;
            }
        }

        /**
         * Returns the shop with the given identifier.
         *
         * @param {string} identifier The identifier to match
         * @param {string} floorUid The identifier of the floor
         * @return {{area: string, name: string, uri: string}}
         */
        function getShop(identifier, floorUid) {
            if ('string' !== typeof identifier) {
                throw new Error('Argument 1 of CenterPlan.getShop has to be of type string, "' + (typeof identifier) + '" given.');
            }
            if (!identifier) {
                throw new Error('Unable to select area: No shop identifier specified.');
            }
            if (!(identifier in settings.floors[floorUid].shops)) {

                throw new Error('Unable to select area: No shop with identifier "' + identifier + '" found.');
            }
            return settings.floors[floorUid].shops[identifier];
        }

        /**
         * Initializes all floors of the center plan.
         *
         * @private
         */
        function _initializeFloors() {
            var floors = element.querySelectorAll('.tx-theme-centerplan-floors .tab-pane');
            for (var i = floors.length; i-->0;) {
                var floor = floors[i],
                    graphic = floor.querySelector('svg');
                _initializeAreas(graphic, floor.dataset.uid);
            }
        }

        /**
         * Initializes all areas of a single SVG.
         *
         * @param {SVGElement} graphic The SVG of which to initialize all areas
         * @param {int} floorUid The uid of the floor
         * @private
         */
        function _initializeAreas(graphic, floorUid) {
            var shopsOnCurrentFloor = settings.floors[floorUid].shops;

                // graphics working with IDs
            var areas = graphic.querySelectorAll('[id^="shop"]'),
                area, i, id, s, sections;
            for (i = areas.length; i-->0;) {
                area = areas[i];
                id = area.id.slice(4);
                if (id && area.id !== 'shops') {
                    if ('g' === area.tagName) {
                        sections = area.querySelectorAll('path, polygon, rect');
                    } else {
                        sections = [area];
                    }
                    for (s = sections.length; s-->0;) {
                        sections[s].dataset.shopId = id;
                        sections[s].addEventListener('click', _jumpToArea.bind(this));
                        sections[s].addEventListener('mouseover', _selectArea.bind(this));
                        sections[s].addEventListener('mouseout', _selectArea.bind(this));
                    }
                }
            }
                // graphics working with classes
            areas = graphic.querySelectorAll('.ebene_css');
            for (i = areas.length; i-->0;) {
                area = areas[i];
                var shopId = null,
                    shopIdPlaceholder = null,
                    matches = (area.id || '').match(/^stp_(.+)$/);

                if (matches) {
                    shopId = matches[1];
                }

                if (!shopId) {
                    var className = area.className instanceof SVGAnimatedString ? area.className.baseVal : area.className;
                    matches = className.match(/(^|\W)stp_([^ ]+)(\W|$)/);
                    if (matches) {
                        shopId = matches[2];
                    }
                }


                area.dataset.shopId = shopId;

                area.addEventListener('click', _jumpToArea.bind(this));
                area.addEventListener('mouseover', _selectArea.bind(this));
                area.addEventListener('mouseout', _selectArea.bind(this));
            }
        }

        /**
         * Selects an area.
         *
         * @param {MouseEvent} event The corresponding event
         * @private
         */
        function _selectArea(event) {
            switch (event.type) {
                case 'mouseover':
                    var floor = event.target.closest('.tx-theme-centerplan-floors .tab-pane[data-uid]'),
                        floorUid = floor.dataset.uid,
                        shop = null;
                    try {
                        shop = getShop(event.target.dataset.shopId, floorUid);
                    } catch (e) {}

                    if (shop) {
                        setShopTitle(shop.name);
                    } else {
                        setShopTitle('Shop #' + event.target.dataset.shopId);
                    }

                    break;
                case 'mouseout':
                    setShopTitle('');
                    break;
            }
        }

        /**
         * Jumps to an area.
         *
         * @param {MouseEvent} event The corresponding event
         * @private
         */
        function _jumpToArea(event) {
            var floor = event.target.closest('.tx-theme-centerplan-floors .tab-pane[data-uid]'),
                floorUid = floor.dataset.uid,
                shop = getShop(event.target.dataset.shopId, floorUid);
            window.location.href = shop.uri;
        }

        initialize();
    }

    /**
     * The main object handling center plans.
     *
     * @constructor
     */
    function Core() {

        /**
         * Initializes all center plans found.
         */
        function init() {
            var containers = document.querySelectorAll('.tx-theme-centerplan[data-identifier]');
            for (var i = containers.length; i-->0;) {
                this.initialize(containers[i]);
            }
        }

        /**
         *
         * Initializes a single center plan.
         *
         * @param {HTMLElement} element The element to initialize
         */
        this.initialize = function(element) {
            new CenterPlan(element);
        };

            // initialize center plans as soon as the DOM is ready
        if ('interactive' === document.readyState || 'complete' === document.readyState) {
            init.call(this);
        } else {
            document.addEventListener('DOMContentLoaded', init.bind(this));
        }

    }

        // export to global scope
    window.IGI = window.IGI || {};
    window.IGI.CenterPlan = new Core();

})();